//import Swiper from 'swiper';
import Alpine from "alpinejs";
import request from 'oc-request';
import cart from './cart.js';
import accordion from './accordion.js';
import videoPlayer from './videoPlayer.js';
import Clipboard from "@ryangjchandler/alpine-clipboard";
import swiper from './swiper.js';

Alpine.plugin(Clipboard);

document.addEventListener('alpine:init', () => {

    Alpine.data('cart', cart);
    Alpine.data('accordion', accordion);
    Alpine.data('videoPlayer', videoPlayer);
    Alpine.data('swiper', swiper);
    
    Alpine.data('templateData', (data) => ({
        formTab: 'main',
        sidebarOpen: false,
        focused: false,
        listPopup: false,
        headNav: false,
        mobileMenuOpen: false,
        searchMenu: false, 

        signUp(email) {
            this.request('ContactsForm::onFormSend', {
                data: {email: email},
                loading: '.preloader-selector'
            });
        },

        isSearchOpen() {
            return this.searchMenu === true;
        },

        searchToggle() {
            this.searchMenu = !this.isAdded
        },

        searchClose() {
            this.searchMenu = false
        },

        request(hendler, options) {
            return request.sendData(hendler, options);
        }
    }));
});

Alpine.start();
